export const CURRENT_VIEW = 'CURRENT_VIEW';
export const CLEAN_UP = 'CLEAN_UP';
export const OVERRIDE_ACCOUNTS_DATA = 'OVERRIDE_ACCOUNTS_DATA';
export const SET_INITIAL_STATE_FOR_ACCOUNTS = 'SET_INITIAL_STATE_FOR_ACCOUNTS';
export const SET_ACCOUNT_HOLDER_OPTIONS = 'SET_ACCOUNT_HOLDER_OPTIONS';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const UPDATE_ACCOUNTS_DATA = 'UPDATE_ACCOUNT_DATA';
export const UPDATE_SELECTED_ACCOUNT = 'UPDATE_SELECTED_ACCOUNT';

export const setInitialStateForAccounts = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_ACCOUNTS,
  payload: data,
});

export const setAccountHolderOptions = (data: any) => ({
  type: SET_ACCOUNT_HOLDER_OPTIONS,
  payload: data,
});

export const setSelectedAccount = (account: any) => ({
  type: SET_SELECTED_ACCOUNT,
  payload: account,
});

export const updateSelectedAccount = (data: any) => ({
  type: UPDATE_SELECTED_ACCOUNT,
  payload: data,
});

export const setCurrentView = (page: string) => ({
  type: CURRENT_VIEW,
  payload: page,
});

export const cleanup = () => ({
  type: CLEAN_UP,
});

export const updateAccountsData = (data: any) => ({
  type: UPDATE_ACCOUNTS_DATA,
  payload: data,
});

export const overrideAccountsData = (accountsData: Record<string, any>) => ({
  type: OVERRIDE_ACCOUNTS_DATA,
  payload: accountsData,
});
